import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AdminData_Service } from './admindata/admin-data.service';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GoogleAnalyticsService {
  private googleAnalyticsScript: string = '';

  constructor(
    private adminDataService: AdminData_Service,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  async loadGoogleAnalyticsScript(): Promise<string> {
    try {
      const data = await firstValueFrom(this.adminDataService.getGoogleAnalytics());
      if (data && Array.isArray(data) && data.length > 0 && data[0].description) {
        this.googleAnalyticsScript = data[0].description as string;
        return this.googleAnalyticsScript;
      }
    } catch {
      // yut
    }
    return '';
  }

  getGoogleAnalyticsScript(): string {
    return this.googleAnalyticsScript;
  }

  injectClientSideScript(): void {
    if (!isPlatformBrowser(this.platformId) || !this.googleAnalyticsScript) return;

    // Zaten yüklenmişse tekrar ekleme
    if (document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) return;

    const snippet = this.googleAnalyticsScript;

    // Snippet <script> içeriyorsa parse et ve tek tek ekle
    if (snippet.includes('<script')) {
      const scriptRegex = /<script\b([^>]*)>([\s\S]*?)<\/script>/gi;
      let match: RegExpExecArray | null;

      while ((match = scriptRegex.exec(snippet)) !== null) {
        const attrs = match[1] || '';
        const body = match[2] || '';

        // src yakala
        const srcMatch = attrs.match(/src=["']([^"']+)["']/i);
        const hasAsync = /\basync\b/i.test(attrs);
        const idMatch = attrs.match(/id=["']([^"']+)["']/i);

        // Eğer dış kaynak ise ve zaten varsa atla
        if (srcMatch) {
          const src = srcMatch[1];
          if (document.querySelector(`script[src="${src}"]`)) continue;
          const s = document.createElement('script');
          s.src = src;
          if (hasAsync) s.async = true;
          if (idMatch) s.id = idMatch[1];
          s.setAttribute('data-google-analytics', 'true');
          document.head.appendChild(s);
        } else {
          // inline script
          const s = document.createElement('script');
          if (hasAsync) s.async = true;
          if (idMatch) s.id = idMatch[1];
          s.text = body;
          s.setAttribute('data-google-analytics', 'true');
          document.head.appendChild(s);
        }
      }
      return;
    }

    // Aksi halde sade JS kodu olarak ekle
    const s = document.createElement('script');
    s.text = snippet;
    s.setAttribute('data-google-analytics', 'true');
    document.head.appendChild(s);
  }
}
